(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('PatientMedicationMarsSignDialogController', PatientMedicationMarsSignDialogController);

    PatientMedicationMarsSignDialogController.$inject = ['take', 'takes', 'chart', '$uibModalInstance',
        'PatientMedicationTakeComment', 'toastr', 'ParseLinks', 'AlertService',
        'PatientMedicationTake', 'CoreService', 'WizardHandler'];

    function PatientMedicationMarsSignDialogController(take, takes, chart, $uibModalInstance,
                                                       PatientMedicationTakeComment, toastr, ParseLinks, AlertService,
                                                       PatientMedicationTake, CoreService, WizardHandler) {
        var vm = this;

        vm.takes = takes;
        vm.take = take;
        vm.chart = chart;

        vm.title = "Sign Medication";

        vm.isPatientSigned = false;
        vm.isEmployeeSigned = false;
        vm.odsPatientSignatureNameId = Math.floor((Math.random() * 100) + 1);
        vm.odsEmployeeSignatureNameId = Math.floor((Math.random() * 100) + 1);
        vm.employeeSignatureAgree = false;
        vm.patientSignatureAgree = false;
        vm.employee = CoreService.getCurrentEmployee();
        vm.facility = CoreService.getCurrentFacility();

        vm.status = {
            SCHEDULED: 'SCHEDULED',
            SYSTEM_MISS: 'SYSTEM_MISS',
            HOLD: 'HOLD',
            ADMINISTERED: 'ADMINISTERED',
            OBSERVED: 'OBSERVED',
            MISSED: 'MISSED'
        }

        vm.signatureOpts = {
            width: 620,
            height: 250,
            cssClass: 'signature-canvas',
            color: '#00008B',
            'background-color': '#fff'
        }

        vm.patientSignature = "";
        vm.employeeSignature = "";

        vm.clear = clear;
        vm.signTakeByPatient = signTakeByPatient;
        vm.signTakeByEmployee = signTakeByEmployee;

        init();

        function init() {
            if (takes.ids.length > 1) {
                vm.isPatientSigned = false;
                vm.isEmployeeSigned = false;
            } else {
                // vm.isPatientSigned = take != null && take.patientSignatureId != null;
                // vm.isEmployeeSigned = take != null && take.observedSignatureId != null;

                vm.isPatientSigned = take.patientSignatureId != null;
                vm.isEmployeeSigned = take.observedSignatureId != null || take.missedSignatureId != null;

                if (vm.isPatientSigned && vm.isEmployeeSigned) {
                    toastr.info('No signature required');

                    $uibModalInstance.close();
                }
            }
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function signTakeByPatient() {
            PatientMedicationTake.signTakeByPatient({
                takes: takes.ids,
                patientSignature: vm.patientSignature,
                facilityId: vm.facility.id
            }, function (result) {
                vm.take = result;
                vm.isPatientSigned = true;

                toastr.success('Patient Sign Successfully');
                if (vm.isPatientSigned && vm.isEmployeeSigned) {
                    clear();
                } else {
                    WizardHandler.wizard('patientMedicationObservedWizard').next();
                }
            }, function () {
                toastr.error('Error signing medication');
            });
        }

        function signTakeByEmployee() {
            PatientMedicationTake.signTakeByEmployee({
                takes: takes.ids,
                employeeSignature: vm.employeeSignature,
                facilityId: vm.facility.id
            }, function (result) {
                vm.take = result;
                vm.isEmployeeSigned = true;

                toastr.success('Employee Sign Successfully');
                if (vm.isPatientSigned && vm.isEmployeeSigned) {
                    clear();
                } else {
                    WizardHandler.wizard('patientMedicationObservedWizard').previous();
                }
            }, function () {
                toastr.error('Error signing medication');
            });
        }
    }
})();
